module.exports = __webpack_public_path__ + "img/icon-edit.54919a2b.svg";